


















































































































































































































































































































































































import { Component, Ref, Vue } from "vue-property-decorator";

@Component({
  name: "AgenciesCustomReportGuide",
})
export default class AgenciesCustomReportGuide extends Vue {
  @Ref() reportSection!: HTMLElement;
  @Ref() templateSection!: HTMLElement;

  scrollToSection(section: HTMLElement) {
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
